import { useEffect, useState } from 'react';
import { getAllCaseList } from 'api/textVisit';
import { CaseListFilter, CaseListItem } from 'types/textVisit';

interface IUseGetAllCaseProps {
    filter: CaseListFilter;
}

export default function useGetAllCase(props: IUseGetAllCaseProps): [CaseListItem[], boolean, (filter: CaseListFilter) => void] {
    const [loading, setLoading] = useState(false);
    const [caseList, setCaseList] = useState<CaseListItem[]>([]);

    const fetchData = async (filter: CaseListFilter) => {
        try {
            setLoading(true);
            const result = await getAllCaseList(filter);
            if (!result.error) {
                const data: CaseListItem[] = result?.data?.data?.list || [];
                setCaseList(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData(props.filter);
    }, []);

    return [caseList, loading, fetchData];
};
